import { useEffect, useState } from 'react';
import { api } from '../api/client';

/**
 * Tarjeta de un render de video-spot (tool render_spot del agente xvision-spot).
 * Poolea GET /render/jobs/:jobId y muestra el video al terminar.
 */
export function RenderJobCard({ jobId }: { jobId: string }) {
  const [status, setStatus] = useState<'queued' | 'rendering' | 'done' | 'error'>('queued');
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let stop = false;
    (async () => {
      for (let i = 0; i < 150 && !stop; i++) {
        await new Promise((r) => setTimeout(r, 2000));
        try {
          const j = await api.get<{ status: string; url?: string; error?: string }>(
            `/render/jobs/${jobId}`,
          );
          if (stop) return;
          if (j.status === 'rendering') setStatus('rendering');
          if (j.status === 'done' && j.url) {
            setUrl(j.url);
            setStatus('done');
            return;
          }
          if (j.status === 'error') {
            setError(j.error ?? 'El render falló.');
            setStatus('error');
            return;
          }
        } catch {
          /* job aún no visible / red — seguimos pooleando */
        }
      }
    })();
    return () => {
      stop = true;
    };
  }, [jobId]);

  return (
    <div className="mt-2 bg-slate-950/60 border border-vision/40 rounded-lg p-2">
      {url ? (
        <>
          <video src={url} controls className="w-full rounded-md" />
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className="block text-center text-[11px] text-vision mt-1 hover:underline"
          >
            Abrir / descargar
          </a>
        </>
      ) : error ? (
        <div className="text-[11px] text-red-400 whitespace-pre-wrap">🎬 {error}</div>
      ) : (
        <div className="text-[11px] text-slate-400">
          🎬 {status === 'queued' ? 'Video en cola…' : 'Renderizando el video…'} (~30-60s)
        </div>
      )}
    </div>
  );
}
